module.exports = __webpack_public_path__ + "static/media/ASLA_FL Logo.122cfd71.png";